import React, { useState } from "react";

const AnsibleForm = ({ onCreate, onCancel }) => {
  const [form, setForm] = useState({
    name: "",
    playbook_content: "",
    inventory_content: "",
  });

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!form.name.trim()) return alert("이름을 입력하세요.");
    onCreate(form);
    setForm({ name: "", playbook_content: "", inventory_content: "" });
  };

  return (
    <form onSubmit={handleSubmit} className="bg-white p-6 rounded shadow mb-6">
      <h2 className="text-xl font-bold mb-4 text-[#3B82F6]">📝 새 작업 생성</h2>

      <div className="mb-4">
        <label className="block text-sm font-semibold mb-1">이름</label>
        <input
          name="name"
          value={form.name}
          onChange={handleChange}
          className="w-full border px-3 py-2 rounded"
        />
      </div>

      <div className="mb-4">
        <label className="block text-sm font-semibold mb-1">Playbook 내용</label>
        <textarea
          name="playbook_content"
          value={form.playbook_content}
          onChange={handleChange}
          rows={6}
          className="w-full border px-3 py-2 rounded"
        />
      </div>

      <div className="mb-4">
        <label className="block text-sm font-semibold mb-1">Inventory 내용</label>
        <textarea
          name="inventory_content"
          value={form.inventory_content}
          onChange={handleChange}
          rows={4}
          className="w-full border px-3 py-2 rounded"
        />
      </div>

      <div className="flex justify-end space-x-2">
        <button type="submit" className="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600">
          등록
        </button>
        <button type="button" onClick={onCancel} className="bg-gray-400 text-white px-4 py-2 rounded">
          취소
        </button>
      </div>
    </form>
  );
};

export default AnsibleForm;
